
























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import jquery from 'jquery';
import '@/assets/js/amazon-connect-chat-interface.js';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';

import uuid from 'uuid/v4';

@Component({
	name: 'LiveChat',
	components: {
		Loading,
		Alert,
	},
})
export default class LiveChat extends Vue {
	@Getter('user', { namespace: 'Auth' }) private user: any;
	private loading: boolean = false;
	private error: boolean = false;
	private displayLiveChat: boolean = false;
	private startFormProps = {
		name: '',
		email: '',
	};
	// @ts-ignore
	private connect = window.connect;

	@Watch('user')
	private watchuser() {
		if (this.user?.name) {
			this.startFormProps.name = this.user.name;
			this.startFormProps.email = this.user.email;
		}
	}

	private startChat() {
		this.displayLiveChat = true;
		this.loading = true;
		this.error = false;

		// @ts-ignore
		window.connect.ChatInterface.init({
			containerId: 'chatWindow',
			headerConfig: {
				isHTML: true,
				render: () => {
					return `
                                <div class="header-wrapper">
                                    <p id="chatDescription">You are being placed in a queue.</p>
                                </div>
                            `;
				},
			},
		});

		console.log('User Data', this.startFormProps);

		try {
			const ChatParams = {
				name: this.startFormProps.name,
				username: uuid(),
				region: 'us-west-2',
				apiGatewayEndpoint: process.env.VUE_APP_CONNECT_API_GATEWAY,
				contactAttributes: JSON.stringify({
					customerName: this.startFormProps.name,
					customerEmail: this.startFormProps.email,
				}),
				contactFlowId: process.env.VUE_APP_CONNECT_CONTACT_FLOW_ID,
				instanceId: process.env.VUE_APP_CONNECT_INSTANCE_ID,
			};

			// @ts-ignore
			window.connect.ChatInterface.initiateChat(
				ChatParams,
				this.successHandler,
				this.failureHandler,
			);
		} catch (e) {
			console.log(e);
		}
	}

	private successHandler(chatSession) {
		console.log('chatsession', chatSession);
		this.loading = false;
		// Change the incoming data set
		chatSession.incomingItemDecorator = item => {
			if (['SYSTEM_MESSAGE'].indexOf(item.displayName) !== -1) {
				item.displayName = 'System Message';
			}

			if (chatSession.transcript.length > 0) {
				// console.log(chatSession.transcript);
				const transcriptItem = chatSession.transcript[chatSession.transcript.length - 1];
				if (transcriptItem.transportDetails.direction === 'Incoming') {
					let chatDescription = '';
					const name = transcriptItem.displayName;
					if (
						[
							'prod',
							'$LATEST',
							'AI Assistant',
							'SYSTEM_MESSAGE',
							'System Message',
						].indexOf(name) === -1
					) {
						chatDescription = 'You are now chatting with ' + name;
					}
					document.getElementById('chatDescription').innerHTML = chatDescription;
				}
			}

			return item;
		};

		chatSession.onIncoming(data => {
			console.log('incoming message:|| ' + JSON.stringify(data));
		});

		chatSession.onOutgoing(data => {
			// console.log("outgoing message: " + JSON.stringify(data));
		});

		chatSession.onChatDisconnected(data => {
			this.loading = true;
			this.startFormProps = {
				name: '',
				email: '',
			};

			this.displayLiveChat = false;
			this.loading = false;
		});

		// @ts-ignore
		window.connect.ChatInterface.init({
			containerId: 'chatWindow',
			headerConfig: {
				isHTML: true,
				render: () => {
					return `
                                <div class="header-wrapper">
                                    <p id="chatDescription">You are being placed in a queue.</p>
                                </div>
                            `;
				},
			},
		});
	}

	private failureHandler(error) {
		console.log('failed', error);
		this.error = true;
		this.loading = true;
		this.startFormProps = {
			name: '',
			email: '',
		};

		this.displayLiveChat = false;
		this.loading = false;
	}

	private created() {
		// @ts-ignore
		window.$ = jquery;

		if (this.user?.name) {
			this.startFormProps.name = this.user.name;
			this.startFormProps.email = this.user.email;
		}
	}
}
